import styled from "styled-components";

export const OrganizationToChooseContainer = styled.div`
  margin-top: 4rem;

  background: ${({ theme }) => theme.console.backgroundColor};
  height: 100%;
  margin: 0;

  width: 100%;
  padding: 6rem 1rem;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (max-width: 600px) {
    justify-content: flex-start;
    padding-top: 2rem;
  }

  h1 {
    font: 600 2rem/2.5rem "Inter";
    color: ${({ theme }) => theme.console.pageTitleColor};

    margin-bottom: 3rem;
    text-align: center;

    max-width: 395px;

    @media (max-width: 600px) {
      font: 600 1.5rem/1.875rem "Inter";
    }
  }

  ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    align-items: flex-start;
    gap: 5rem;

    @media (max-width: 600px) {
      gap: 3.375rem;
    }
  }
`;
